"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewTabIcon = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NewTabIcon = function NewTabIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.1665 0H16.1665C16.4165 0 16.6665 0.25 16.6665 0.5V5.5C16.6665 5.78125 16.4165 6 16.1665 6C15.8853 6 15.6665 5.78125 15.6665 5.5V1.71875L8.01025 9.375C7.82275 9.5625 7.479 9.5625 7.2915 9.375C7.104 9.1875 7.104 8.84375 7.2915 8.65625L14.9478 1H11.1665C10.8853 1 10.6665 0.78125 10.6665 0.5C10.6665 0.25 10.8853 0 11.1665 0ZM2.6665 2H7.1665C7.4165 2 7.6665 2.25 7.6665 2.5C7.6665 2.78125 7.4165 3 7.1665 3H2.6665C2.104 3 1.6665 3.46875 1.6665 4V14C1.6665 14.5625 2.104 15 2.6665 15H12.6665C13.1978 15 13.6665 14.5625 13.6665 14V9.5C13.6665 9.25 13.8853 9 14.1665 9C14.4165 9 14.6665 9.25 14.6665 9.5V14C14.6665 15.125 13.7603 16 12.6665 16H2.6665C1.5415 16 0.666504 15.125 0.666504 14V4C0.666504 2.90625 1.5415 2 2.6665 2Z",
    fill: "#006FC4"
  }));
};

exports.NewTabIcon = NewTabIcon;